import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-state-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './state-footer.component.html',
  styleUrl: './state-footer.component.scss'
})
export class StateFooterComponent {
finalDate: string;

  constructor() {
    const today = new Date();
    const formattedDate = today.toLocaleDateString('en-GB'); // dd/MM/yyyy
    this.finalDate = formattedDate.replace(/\//g, '-');      // dd-MM-yyyy
  }
}
